<div>
    <bs-datepicker-inline [bsConfig]="{ minMode: 'day' }" [bsValue]="selectDate"></bs-datepicker-inline>
    <div class="date-btns-container">
        <button>Today</button>
        <button>Tomorrow</button>
        <button>This Week</button>
        <button>Next Week</button>
    </div>
</div>